const AutoClearFlash = {
	mounted() {
		this.timer = setTimeout(() => {
			this.el.classList.remove("animate-bounce-in-up");
			this.el.classList.add("animate-bounce-out-down");
			setTimeout(() => {
				this.pushEvent("lv:clear-flash", { key: this.el.dataset.kind });
			}, 300);
		}, 5e3);
	},
	destroyed() {
		clearTimeout(this.timer);
	}
};
export default AutoClearFlash;
